// extracted by mini-css-extract-plugin
export default {"spinner":"SpinnerLoading_spinner__gcyBD"};